import { ICON__x_mark_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';

interface PROPS {}

export function G_BUTTON__add_special_tokens_cancel({}: PROPS) {
  const dispatch = use_dispatch();

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_general__field_to_add_special_tokens', field: FIELD__list_token.CREATE_STUB() }));
  }
  /*
   *
   */

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-bar"
      size="rect-10-5"
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={ICON__x_mark_solid}
      {...{ onClick }}
    ></UI_PRIMITIVE__button_with_icon_animated>
  );
}
